import { render, staticRenderFns } from "./NormalSearchNav63.vue?vue&type=template&id=71f27c96&scoped=true&"
import script from "./NormalSearchNav63.vue?vue&type=script&lang=js&"
export * from "./NormalSearchNav63.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71f27c96",
  null
  
)

export default component.exports